var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnansweredNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18035_15077)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18035_15077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C10.0716 22.75 8.18657 22.1782 6.58319 21.1068C4.97982 20.0355 3.73013 18.5127 2.99218 16.7312C2.25422 14.9496 2.06114 12.9892 2.43735 11.0979C2.81355 9.20656 3.74215 7.46928 5.10571 6.10571C6.46928 4.74215 8.20656 3.81355 10.0979 3.43735C11.9892 3.06114 13.9496 3.25422 15.7312 3.99218C17.5127 4.73013 19.0355 5.97982 20.1068 7.58319C21.1782 9.18657 21.75 11.0716 21.75 13C21.745 15.5843 20.7162 18.0614 18.8888 19.8888C17.0614 21.7162 14.5843 22.745 12 22.75ZM12 4.75C10.3683 4.75 8.77326 5.23386 7.41655 6.14038C6.05984 7.0469 5.00242 8.33538 4.378 9.84287C3.75358 11.3504 3.5902 13.0092 3.90853 14.6095C4.22685 16.2098 5.01259 17.6799 6.16637 18.8336C7.32016 19.9874 8.79017 20.7732 10.3905 21.0915C11.9909 21.4098 13.6497 21.2464 15.1571 20.622C16.6646 19.9976 17.9531 18.9402 18.8596 17.5835C19.7661 16.2268 20.25 14.6317 20.25 13C20.2475 10.8127 19.3775 8.71575 17.8309 7.16911C16.2843 5.62248 14.1873 4.75249 12 4.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.75C17 12.9489 16.9506 13.1397 16.8627 13.2803C16.7748 13.421 16.6556 13.5 16.5312 13.5H7.46875C7.34443 13.5 7.2252 13.421 7.13729 13.2803C7.04939 13.1397 7 12.9489 7 12.75C7 12.5511 7.04939 12.3603 7.13729 12.2197C7.2252 12.079 7.34443 12 7.46875 12H16.5312C16.6556 12 16.7748 12.079 16.8627 12.2197C16.9506 12.3603 17 12.5511 17 12.75Z",
    fill: "#C4C4C4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 5.5,
    fill: "#4CAF50",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18035_15077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18035_15077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnansweredNew);
export default __webpack_public_path__ + "static/media/icon-unanswered-new.d43140ce318fe327d87627ed0eb2dce7.svg";
export { ForwardRef as ReactComponent };